import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiEditorText } from '@wix/da-papi-types';
import JournalViewerV3 from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Journal';
import TextRenderer from '../../../../TextRenderer';
import { MatureDeviationContext } from '../../../../Context/MatureDeviationContext';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';

export interface Props {
  deviationId: number;
  textContent?: PapiEditorText;
  className?: string;
  disableStylesForLegacy?: boolean;
}

const TextContent: React.FC<Props> = ({
  textContent,
  className,
  deviationId,
  disableStylesForLegacy,
}) => {
  const { t } = useTranslation();
  const { showBlocked } = useContext(MatureDeviationContext);

  return showBlocked ? (
    <div className={className}>{t('deviation.details.hiddenContent')}</div>
  ) : (
    <TextRenderer
      className={className}
      textContent={textContent}
      tipTapViewer={JournalViewerV3}
      withSafetyCheckModal
      cookieType={MeasuredCookieType.EDITOR_JOURNAL}
      defaultSize={{
        desktop: { width: 780, height: 40 },
        mobile: { width: 380, height: 80 },
      }}
      viewerKey={deviationId}
      legacyTheme="journal"
      disableStylesForLegacy={disableStylesForLegacy}
    />
  );
};
TextContent.displayName = 'TextContent';

export default TextContent;
